module.exports = __webpack_public_path__ + "assets/img/favicon/ms-icon-150x150.76609da2f174547d440a6f53c48ffcb0.png";